// extracted by mini-css-extract-plugin
export default {"prompt":"Prompt_prompt__J4r3n","expanded":"Prompt_expanded__xs60q","collapsed":"Prompt_collapsed__3Muz4","icon":"Prompt_icon__2v5UJ","content":"Prompt_content__P+A2y"};